// Kunden-Version, Block 3: Eine Umzugsfirma möchte die Aufnahme übernehmen.
// Link aus der Mail: scan.umzugsscan.app/u/<token>. Ohne Zustimmung passiert nichts.

import { useEffect, useState } from "react";
import { api } from "../api.ts";
import { errorText } from "../texte.ts";
import { Button } from "../ui/elemente.tsx";
import { RechtLinks } from "../ui/Recht.tsx";
import { PrivatKopf } from "./PrivatStart.tsx";

type Info = {
  status: "angefragt" | "bestaetigt" | "abgelehnt";
  code: string | null;
  company: { name: string; city: string | null; phone: string | null; email: string | null; website: string | null; logoUrl: string | null };
  resumeUrl: string | null;
};

export function Uebernahme(props: { token: string }) {
  const [info, setInfo] = useState<Info | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const url = `/privat/uebernahme/${encodeURIComponent(props.token)}`;

  useEffect(() => {
    api.request<Info>("GET", url).then(setInfo, (e) => setError(errorText(e)));
  }, [url]);

  const decide = async (accept: boolean) => {
    setBusy(true);
    setError(null);
    try {
      const r = await api.request<{ status: Info["status"] }>("POST", url, { accept });
      setInfo((i) => (i ? { ...i, status: r.status } : i));
    } catch (e) {
      setError(errorText(e));
    } finally {
      setBusy(false);
    }
  };

  const c = info?.company;
  return (
    <div className="app">
      <PrivatKopf />
      <main className="main">
        {!info && !error && <div className="spinner" style={{ margin: "48px auto" }} aria-label="Wird geladen" />}
        {!info && error && (
          <section className="danke">
            <h1>Link nicht gültig</h1>
            <p>{error}</p>
          </section>
        )}
        {info && c && (
          <>
            {c.logoUrl && <img className="logo" src={c.logoUrl} alt={c.name} style={{ margin: "8px 0 12px" }} />}
            {info.status === "angefragt" && (
              <>
                <h1>{c.name} möchte Ihre Aufnahme übernehmen</h1>
                <p className="lead">
                  {c.name}
                  {c.city ? ` aus ${c.city}` : ""} möchte Ihnen mit Ihrer Umzugsaufnahme {info.code ? `(Code ${info.code}) ` : ""}ein Angebot machen.
                </p>
                <section className="card">
                  <h2>Was die Firma bekommt</h2>
                  <p>Eine Kopie Ihrer Aufnahme: Name, Telefon, E-Mail, Wunschtermin, Adressen, Räume, Möbel und Fotos.</p>
                  <p className="hint">
                    Ihre eigene Aufnahme bleibt bei Ihnen. Für die Kopie ist danach {c.name} verantwortlich; wenn Sie Ihre Aufnahme löschen,
                    wenden Sie sich für die Kopie an {c.name}.
                  </p>
                </section>
                {(c.phone || c.email || c.website) && (
                  <p className="hint">
                    Kontakt: {[c.phone, c.email, c.website].filter(Boolean).join(" · ")}
                  </p>
                )}
                {error && <p className="error">{error}</p>}
                <div className="stack">
                  <Button onClick={() => void decide(true)} disabled={busy}>
                    Zustimmen
                  </Button>
                  <Button variant="secondary" onClick={() => void decide(false)} disabled={busy}>
                    Ablehnen
                  </Button>
                </div>
              </>
            )}
            {info.status === "bestaetigt" && (
              <section className="danke">
                <div className="check-big" aria-hidden="true">
                  ✓
                </div>
                <h1>Zugestimmt</h1>
                <p>{c.name} hat jetzt eine Kopie Ihrer Aufnahme und meldet sich mit einem Angebot bei Ihnen.</p>
              </section>
            )}
            {info.status === "abgelehnt" && (
              <section className="danke">
                <h1>Abgelehnt</h1>
                <p>{c.name} bekommt Ihre Aufnahme nicht.</p>
              </section>
            )}
            {info.resumeUrl && info.status !== "angefragt" && (
              <p style={{ textAlign: "center" }}>
                <a href={info.resumeUrl}>Zu meiner Aufnahme</a>
              </p>
            )}
          </>
        )}
        <RechtLinks privat />
      </main>
    </div>
  );
}
